import React from 'react';
import { Report } from 'apiTypes';
import { PromptGroup } from 'types/candidateStories';

const CandidateStoryPromptSummary = ({
  candidateStories,
  selectedRecords,
  promptGroups,
}: {
  candidateStories: any;
  selectedRecords: Report[];
  promptGroups: PromptGroup[];
}) => {
  return (
    <div data-testid='candidate-story-prompt-summary'>
      CandidateStoryPromptSummary
    </div>
  );
};

export default CandidateStoryPromptSummary;
